import _ from 'underscore';

/**
 * Format campaign bulk api error
 * @param {Array} errors - array of error from MT
 * @param {Integer} addedValue - diff between adinsight error code and campaign error code
 * @return {Array} formatted errors in campaign MT style
 */
export const formatCampaignBulkApiError = (errors, addedValue) => _.map(errors, error => ({
  ErrorNumber: error.ErrorCode - addedValue,
  Error: error.ErrorMessage,
  Property: error.Property,
}));
